import toast from "react-hot-toast";
import { log, supabase } from ".";

export const updateUsuario = async ({ id, email, agencia, cliente_id, cargo }) => {
  try {
    const newUserData = {
      email: email || null,
      agencia: agencia !== undefined ? parseInt(agencia, 10) : null,
      cliente_id: cliente_id !== undefined ? parseInt(cliente_id, 10) : null,
      cargo: cargo !== undefined ? cargo : null, // Añadir soporte para cargo
    };

    const data = await supabase.update("usuarios", newUserData, id);

    if (!data || data.length === 0) {
      toast.error("No se pudo actualizar el usuario");
      throw new Error("No data returned from update");
    }

    return data;
  } catch (error) {
    log.error("updateUsuario", error);
    toast.error("Error al actualizar usuario en la base de datos");
    throw error;
  }
};
